import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Alert, AlertActions, AlertDescription, AlertTitle } from '@/common/components/alert';
import { Button } from '@/common/components/button';
import { useDeleteProject } from '@/projects/queries';

export function DeleteProject({ projectId }: { projectId: number }) {
  const navigate = useNavigate();
  const deleteProjectMutation = useDeleteProject({
    mutationConfig: {
      onSuccess: () => {
        setIsOpen(false);
        void navigate({ to: '/projects' });
      }
    }
  });

  const [isOpen, setIsOpen] = useState(false);

  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  function deleteProject() {
    deleteProjectMutation.mutate({ projectId });
  }

  return (
    <>
      <Button outline color="red" onClick={open}>Delete Project</Button>
      <Alert onClose={setIsOpen} open={isOpen}>
        <AlertTitle>Delete Project</AlertTitle>
        <AlertDescription>
          Are you sure you want to delete this project? This action is permanent and cannot be undone.
        </AlertDescription>
        <AlertActions>
          <Button outline onClick={close}>
            Cancel
          </Button>
          <Button color="red" disabled={deleteProjectMutation.isPending} onClick={deleteProject}>
            Delete Project
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
}
